// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"9053068383fddaae1fb5","966":"dc5de1903c2c3222d97f"}[chunkId] + ".js";
};